/*
 * Feature keys should be added to this file like:
 *
 * ```
 * const featureKeys = Object.freeze({
 *   FEATURE_FLAG_NAME: 'domain.subdomain.feature',
 * });
 * ```
 */

const featureKeys = Object.freeze({
  AUTHORING_PREVENT_CONFIG_ASSET_RESOLVE: 'authoring-brnt-15109',
  LEARNSPACE_DYNAMIC_CALLS_NON_BLOCKING: 'authoring-brnt-15383',
  LEARNSPACE_SOLUTION_1_POC: 'learnspace-brnt-15961',
  LEARNSPACE_POC_V2: 'learnspace-performance-2',
  LEARNSPACE_RTM_SOLUTION_1_POC: 'learnspace-brnt-16436',
});

export default featureKeys;
